import { Base64 } from '@shared/utils/base64.mjs'
import { isLargeViewPort } from '@remote/utils/base'
/**
 * 调起本地PC迅雷播放
 * @param file 文件信息
 */
export const playInThunder = ({ space, userID, fileID }: { fileID: string; userID: string; space: string }) => {
  const payload = {
    opt: 'nas:play',
    params: {
      fileId: fileID ?? '',
      userid: userID ?? '',
      space: space ?? '',
    },
  }
  console.log('payload', payload)
  const link = Base64.encode(JSON.stringify(payload))
  const thunderLink = `thunderx://${link}`
  if (window.navigator.userAgent.includes('TBC')) {
    if (isLargeViewPort()) {
      const iframe = document.createElement('iframe')
      document.body.append(iframe)
      iframe.style.opacity = '0';
      iframe.style.width = '0'
      iframe.style.height = '0'
      iframe.src = thunderLink
    } else {
      console.log('call window.native.CallNativeFunction', window.native.CallNativeFunction, thunderLink)
      window.native.CallNativeFunction('OnThunderxOpt', thunderLink)
    }
  }
}

/**
 * 转化路径展示文本，转换规则:
 *   - 单级路径不超过6个中文字符，超过6个，末尾...
 *   - 多级路径不超过1行，超过1行，优先展示第一级和最后一级路径，最多展示4级
 * @param {String} path  完整路径
 */
export function transformPath (path: string) {
  const dirs = path.split('/')
  // function getMaxlen (txt: string, byteLimit = 18) {
  //   const len = txt.replace(/[^\x00-\xff]/g, '***').length
  //   if (len <= byteLimit) return txt
  //   for (let i = 0, l = 0; i < txt.length; ++i) {
  //     const c = txt[i]
  //     l += c.match(/[^\x00-\xff]/) !== null ? 3 : 1
  //     if (l > byteLimit) {
  //       return txt.slice(0, i)
  //     } else if (l === byteLimit) {
  //       return txt.slice(0, i + 1)
  //     }
  //   }
  //   return txt
  // }
  const _dirs = dirs.map(dir => {
    // const str = getMaxlen(dir)
    const str = dir.slice(0, 9)
    if (str === dir) return dir
    return `${str}...`
  })
  if (_dirs.length > 4) {
    return _dirs.slice(0, 2).concat(['...'], _dirs.slice(-2)).join('/')
  }
  return _dirs.join('/')
}
